export default {
    cart: {
      account: 'Pengaturan'
    },
    msg:{
      hello: 'hello world'
    },
    message:{
      hello:'hello <br/> world',
      hi:'%{msg} world'
    },
    en: {
      apple: 'no apples | one apple | {count} apples',
      banana: 'no bananas | {n} banana | {n} bananas'
    },
    tips: {
      cart_success: "Has been successfully added to the shopping cart",
      add_success: "Added successfully",
      empty: "Empty~",
      order_success: "Congratulations, the order is submitted successfully",
      chose: "please choose",
      un_pay_on_line: "Currently does not support online payment",
      area_not_empty: "Region cannot be empty",
      name_not_empty: "Name cannot be empty",
      address_not_empty: "Address cannot be empty",
      phone_not_empty: "Phone number is incorrect"
    },
    detail: {
      Delivery_method:'Delivery methods',
      Delivery_information:'Delivery information',
      carriage: 'Shipping',
      Subtotal:'subtotal',
      Total:'total',
      mange:'pamamahala',
      jian:'Piece',
      CloseOrder:'Complete order',
      surplus: 'Remaining',
      goods_detail: 'product details',
      cart: 'shopping cart',
      add_cart: 'Add to cart',
      buy_now: 'Buy now',
      paypaly_method:'Payment methods',
      paypaly1:'Cash on delivery',
      paypaly2:'payments',
      paypalyOut:'In development，wait patiently pls'
    },
    order: {
      freeFreight:'Libreng kargo',
      allTotal:'Total commodity price',
      query:'query',
      goods_info: 'Product information',
      pay_way: 'Choose delivery and payment method',
      offline: 'Cash on delivery',
      online: 'Online payments',
      pick_info: 'Delivery information',
      name_name: 'Name',
      name: "The recipient's name",
      phone_name: 'phone',
      phone: "Recipient's mobile number",
      area: 'Province, city, district, etc.',
      region: 'area',
      address_name: 'Address',
      address: 'Street number, floor room number and other information',
      offer_order: 'Submit Order',
    },
    data: {
      Recipient_name:"The recipient's name",
      Recipient_nameTips:'Please fill in the real name of the recipient to ensure a smooth receipt',
      Select_M:'Choose a store',
      email:"Recipient's mailbox",
      Select_M_number:'Selected store number',
      Selected_store_name:'Selected store name',
      Shop_address:'Store address',
      address:'Please select an address',
      Choose_payment_method:'Selected payment method',
      default_address:'Taiwan',
    },
    indexdata:{
      index:'Home',
      list:'List',
      placeholder:'Enter search keywords',
      Return:'Back'
    },
    Product_details_page: {
      guarantee:'Guarantee',
      guarantee_texts: 'Genuine guarantee, fake one compensation, four fast refund',
      numbertext:'Quantity',
      Select_product_specification:'Order Confirmation',
      Package_selection: 'Course choice',
      Buy_now: 'Confirm purchase'
    },
    newOrder:{
      Order_information:'Order information',
      Selection_of_delivery_and_payment_methods:'Choose delivery and payment method',
      Delivery_place:'Delivery location',
      tw:'Taiwan',
      Delivery_method:'Delivery methods',
      Sub_total:'Subtotal',
      Freight_charges:'Freight',
      Total:'total',
      Go_to_checkout:'Go to checkout',
    },
    //这里只把菲律宾加了 省市区
    order3: {
      Total:'total  ₱',
      Delivery_information:'Delivery information',
      Freight_charges:'Freight',
      change:'change',
      Search_shop:'Search stores',
      Order_notes:'order notes',
      Payment_information:'Payment information',
      Payment_method_selected:'Selected payment method',
      Submit_order: 'Submit the order',
      xxdz:'Please enter detailed address',
      Select_address: 'Province',
      Select_address1: 'City',
      Select_address2: 'District',
      Tell_the_seller:'Do you want to tell the seller?',
      freight:"Freight:",
      Spesifikasi_jualan_pendek:'The specification is sold out'
    },
    index:{
      placeholder:'Enter search keywords',
      index:'Index',
      list: 'List',
      language:'Language'
    },
    Guarantee:{
      num:'Quantity',
      Pickup_method:'Support 7-11, Family Super Merchant Pickup',
      Guarantee:'Quality Assurance',
      Freight:'free shipping',
      Commodity_pic:'Commodity picture',
      Options:'Options',
      selected:'Selected goods',
      Total_price:'Total order price',
      Finally_cope:'Finally_cope',
      message:'leave a message',
      region:'Province',
      region_s:'City',
      village: 'Barangay' ,
      country:'Country/Region',
    },
    Pay:{
      language:'Cash on delivery',
      money:'₱',
      to:'Jump to homepage in seconds',
      postcode:'Postcode',
      setMeal:'Presyo ng package ng kombinasyon',
      success:'successfully ordered!',
      time:'The merchant will automatically confirm your order within 10 minutes!',
      realMoney:'Ang halagang talagang binayaran',
      orderNumber:'Numero ng order',
      waitFor:'Ang merchant ay hindi naipadala, mangyaring maghintay ng matiyaga'
    },
    comment:{
      comment:'Post a comment',
      Praise:'Praise',
      Average:'Average',
      Badreview:'Bad review',
      submitcomments:'submit comments',
      PleaseEnteraComment:'Please enter a comment'
    },
    Toast:{
      inputName:'Please enter a name',
      inputPhone:'Please enter phone number',
      inputZip:'Please enter postcode',
      inputAddress:'Please enter detailed address',
      inputAlertAddress:'The address is not delivered, please change to another address',
    },
    contactUs:{
      callMe:'To learn more <br>,Pls contact the Messenger of our Facebook page!',
      afterShop:`Already shopping,Pls contact us: <br> Email: <a href='mailto:service325@hotmail.com'>service325@hotmail.com</a>`,
      confirm:'OK',
      shortSale:'Binibili na ang detalye',
    },
    ensure:{
      introduce:'Introduction',
      Specifications:'Specification',
      ensure:'Parameter',
      di:'',
      commodity:'th item'
    },
    wuliu:{
      orderSearch:'Order Tracking',
      provide:'This data is provided by the logistics official',
      OrderOrLogistics:'Order number/logistics order number (fill in one to query)',
      orderPlaceho:'Fill in the relevant information query',
      query:'Inquiry order number',
      Tips:'Warm tips',
      Tipsinfo:' If you have any questions after receiving the goods,Please contact online customer service first or send an email to service325@hotmail.com. At the same time, please tell us your name/order number in combination, we will deal with it quickly and promptly, wish you a happy shopping!',
    }
  }
  


// WEBPACK FOOTER //
// ./src/i18n/flb.js